import building from "assets/img/building.svg";
import house from "assets/img/house.svg";
import IndiceDeConfiance from "components/v2/common/IndiceDeConfiance";
import { COUNTRY_CONFIG } from "Config/country";
import { Component } from "react";
// import { default as NumberFormat } from "react-number-format";
import gs from "styles/Global.module.css";
import styles from "./PricesDisplay.module.css";
import { prixFormat } from "utils/PrixFormat";

export class PricesDisplay extends Component {
  componentDidMount() {
    if (this.props.scrollingUp) {
      this.props.scrollingUp();
    }
  }

  render() {
    // const { classes } = this.props;
    // const { lang } = useTranslation("")
    return (
      <div className={styles.appartementvilla_price_display_container} style={{ minHeight: "450px", width: "100%", }}>
        <div className={styles.container}>
          <div className={styles.gridTitles}>
            <h1 className={styles.prices__local__title}>
              {this.props.t("Prix immobilier à")} {this.props.t(this.props.localisation)}
            </h1>
            <h2 className={styles.prices__local__source}>
              {this.props.t(
                "Référentiel des prix immobilier basé sur les données publiques, offres immobilières et transactions partenaires"
              )}
            </h2>
          </div>
          <div className={styles.priceElementsContainer}>
            {this.props.prix_appartement ? (
              <div className={styles.priceContainer}
                lg={this.props.prix_villa ? 6 : 12}
              >
                <div className={styles.typeAndPrice}>
                  <div className={styles.svgTypeContainer}>
                    <img
                      src={building.src}
                      alt="prix moyen des appartements à Casablanca"
                    />
                    <span className={styles.svg__type__bien}>
                      {this.props.t("Appartement")}
                    </span>
                  </div>
                  <div className={styles.price}>
                    <p>{this.props.t("Prix au m² moyen")}</p>
                    <p
                      className="ar-ltr"
                      style={{ fontSize: "24px", fontWeight: "600", direction: this.props.lang == "ar" ? "rtl" : "ltr", textAlign: "right" }}
                    >
                      {/* <NumberFormat
                        displayType={"text"}
                        value={parseInt(this.props.prix_appartement)}
                        thousandSeparator={" "}
                      /> */}
                      <span>&lrm;{prixFormat(parseInt(this.props.prix_appartement))}</span>
                      {` ${this.props.t(
                        COUNTRY_CONFIG[process.env.NEXT_PUBLIC_COUNTRY]
                          .CURRENCY
                      )}`}
                    </p>
                  </div>
                </div>
                <div>
                  <IndiceDeConfiance
                    t={this.props.t}
                    value={this.props.indice_confiance_appartement}
                  />
                </div>
              </div>
            ) : null}
            {this.props.prix_villa ? (
              <div className={styles.priceContainer}
                lg={this.props.prix_appartement ? 6 : 12}
              >
                <div className={styles.typeAndPrice}>
                  <div className={styles.svgTypeContainer}>
                    <img
                      src={house.src}
                      alt="prix moyen des villas à Casablanca"
                    />
                    <span className={styles.svg__type__bien}>
                      {this.props.t("Villa")}
                    </span>
                  </div>
                  <div className={styles.price}>
                    <p>{this.props.t("Prix au m² moyen")}</p>
                    <p style={{ fontSize: "24px", fontWeight: "600", direction: this.props.lang == "ar" ? "rtl" : "ltr", textAlign: "right" }}>
                      {/* <NumberFormat
                        displayType={"text"}
                        value={parseInt(this.props.prix_villa)}
                        thousandSeparator={" "}
                      /> */}
                      <span>&lrm;{prixFormat(parseInt(this.props.prix_villa))}</span>
                      {` ${this.props.t(
                        COUNTRY_CONFIG[process.env.NEXT_PUBLIC_COUNTRY]
                          .CURRENCY
                      )}`}{" "}
                    </p>
                  </div>
                </div>
                <div>
                  <IndiceDeConfiance
                    t={this.props.t}
                    value={this.props.indice_confiance_villa}
                  />
                </div>
              </div>
            ) : null}
          </div>
          <div className={styles.estimerBtnContainer}>
            <p className={styles.estimationTitle} >
              {this.props.t(
                "Estimez votre bien en fonction de ses caractéristiques"
              )}
            </p>
            <a href={`/${this.props.lang}/estimation/map`} className={`${gs.button} ${gs.btn__primary} ${styles.buttonFill}`}>
              {this.props.t("Estimer un bien")}
            </a>
            <p className={styles.pricesUpdateDate}>
              {this.props.last_update
                ? this.props.t("Dernière mise à jour le")
                : ""}{" "}
              {this.props.last_update
                ? new Date(this.props.last_update).toLocaleDateString("fr-FR")
                : ""}
            </p>{" "}
          </div>
        </div>
      </div >
    );
  }
}

export default PricesDisplay;
